const config = {
  useSystemColorMode: false,
}

export default config
